"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterList = void 0;
const react_1 = __importDefault(require("react"));
const sds_1 = require("@squiz/sds");
const types_1 = require("./types");
const CheckboxFilter_1 = require("../CheckboxFilter/CheckboxFilter");
const FilterList = (props) => {
    const { filters, headingLevel, headingText = '', setFilters } = props;
    const getCheckboxFilter = (checkboxFilter) => {
        const { emptyText, icon, id, listHeight, name, values, mode } = checkboxFilter;
        const setFilterOptions = (updatedOptions) => {
            const updatedFilters = filters.map((filter) => {
                if (filter.id === id) {
                    filter.values = updatedOptions;
                }
                return filter;
            });
            setFilters(updatedFilters);
        };
        return (react_1.default.createElement(CheckboxFilter_1.CheckboxFilter, { emptyText: emptyText, filterOptions: values, headingLevel: 4, icon: icon, id: id, name: name, listHeight: listHeight, setFilterOptions: setFilterOptions, mode: mode }));
    };
    const getFilters = () => {
        return filters.map((filter, filterKey) => {
            let filterElement;
            switch (filter.type) {
                case types_1.FilterType.Checkbox:
                    filterElement = getCheckboxFilter(filter);
                    break;
                default:
                    filterElement = null;
            }
            if (!filterElement) {
                return react_1.default.createElement(react_1.default.Fragment, { key: filterKey });
            }
            return (react_1.default.createElement("div", { className: "filter-list__item", key: filterKey }, filterElement));
        });
    };
    return (react_1.default.createElement("div", { className: "filter-list__wrapper" },
        headingText && react_1.default.createElement(sds_1.SdsHeading, { classes: "filter-list__heading", customTag: `h${headingLevel}`, level: 2, text: headingText }),
        react_1.default.createElement("div", { className: "filter-list" }, getFilters())));
};
exports.FilterList = FilterList;
